// extracted by mini-css-extract-plugin
export default {"launcher":"N_dD","launcher__heading":"N_dF","launcher__menu-item":"N_dG"};